import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';
import { ToolbarButtonClickEventData } from './toolbar-button-click-event-data';

export class ToolbarButtonClickedMapEvent implements MapEvent {
    type = MapEventType.toolbarButtonClicked;
    constructor(public payload: ToolbarButtonClickEventData) {}
}
